import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginTop: "100px",
  },
  modal1: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  title: {
    cursor: "pointer",
    fontSize: "12px",
    fontWeight: 600,
    [theme.breakpoints.up("xl")]: {
      fontSize: "16px",
    },
  },
  trackableIcon: {
    padding: "4px 6px",
    borderRadius: "5px",
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.secondary.main,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  object_name: {
    color: theme.palette.secondary.main,
    fontWeight: 500,
    [theme.breakpoints.down("xl")]: {
      fontSize: "12px",
    },
    [theme.breakpoints.up("xl")]: {
      fontSize: "14px",
    },
  },
  modalHead: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    color: theme.palette.secondary.main,
    fontFamily: "Nunito Sans",
  },
  cardDiv: {
    backgroundColor: theme.palette.secondary.light,
    borderRadius: "10px",
  },
  cardContent: {
    margin: "2px",
    padding: "10px",
    display: "flex",
    flexDirection: "column",
    gap: "10px",
  },
  cardTitleContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  date: {
    fontSize: "12px",
    color: theme.palette.text.tertiary,
    textAlign: "end",
  },
  image: {
    cursor: "pointer",
    // marginRight: "10%",
    width: "100%",
    maxHeight: "280px",
    borderRadius: "10px",
  },
  editLogo: {
    margin: "2px",
    color: theme.palette.text.secondary,
    width: "15px",
    borderRadius: "2px",
  },
  editButton: {
    backgroundColor: theme.palette.secondary.main,
    borderRadius: "10px",
    minWidth: "35px",
    height: "35px",
  },
  commentIconDiv: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    cursor: "pointer",
    marginLeft: "10px",
    color: theme.palette.secondary.main,
  },
  commentIcon: {
    margin: "0px",
    padding: "0px",
  },
  canvasDiv: {
    borderRadius: "10px",
    height: "95%",
    width: "95%",
    padding: "2% 5%",
    background: theme.palette.primary.main,
  },
  commentsTools: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "0px 10px",
    color: theme.palette.primary.light,
    // height: "8%",
    margin: "5px 0px",
  },
  statusDropDown: {
    display: "flex",
    alignItems: "center",
    width: "190px",
  },
  input: {
    backgroundColor: theme.palette.primary.main,
    borderRadius: "10px",
    padding: "0px",
    width: "160px",
    color: theme.palette.primary.light,
  },
  menuItem: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.light,
  },
  filterText: {
    display: "flex",
    alignItems: "center",
    color: theme.palette.text.tertiary,
  },
  grayText: {
    color: theme.palette.text.tertiary,
  },
  flexBetween: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  flexCenter: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  status: {
    display: "flex",
    alignItems: "start",
    justifyContent: "end",
    marginRight: "-15px",
  },
  showHide: {
    display: "flex",
    alignItems: "center",
    gap: "5px",
    fontSize: "12px",
  },
  threeDImage: {
    width: "100%",
    height: "250px",
    borderRadius: "10px",
  },
  threeIconContainer: {
    position: "absolute",
    top: 0,
    right: 0,
    display: "flex",
    gap: "5px",
  },
  noteModal: {
    backgroundColor: theme.palette.primary.main,
    alignItems: "flex-start",
    gap: "10px",
    width: "350px",
    borderRadius: "10px",
    border: `1px solid ${theme.palette.secondary.main}`,
    marginTop: "-5px",
    textAlign: "center",
    padding: "4px 10px",
    fontWeight: 600,
    fontSize: "14px",
  },
  updateTile: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
  },
  contentInfoWithUser: {
    backgroundColor: "#1F222E",
    padding: "10px",
    borderRadius: "10px",
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  },
}));

export default useStyles;
